import { css } from '@emotion/core';
import { N200A, N900 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

import {
  SPACE_COMPACT,
  grid,
  SEARCH_LARGE_BREAKPOINT,
  flexCenter,
  SPACE_COZY,
  alignItemsStart,
  SEARCH_XSMALL_BREAKPOINT,
  flexStart,
  spaceGapComfortable,
} from '@/styles';

export const cardSkeletonStyles = css`
  width: 100%;
  padding: ${SPACE_COZY}px;
`;

export const cardBasicSkeletonStyles = css`
  padding-left: ${SPACE_COMPACT}px;
`;
// SLO
export const cardSloContentStyles = [
  css`
    ${flexCenter}
    ${alignItemsStart}
    width: 100%;
    padding: ${SPACE_COZY}px;
    box-sizing: border-box;
  `,
];
export const cardSloGroupContentStyles = css`
  padding: 0px;
`;

// Capability
export const cardCapabilityContentStyles = css`
  padding: ${SPACE_COMPACT}px;
`;
export const capabilityCardStyles = [
  grid,
  css`
    width: 100%;
    gap: ${SPACE_COMPACT}px;
    grid-template-columns: repeat(1, 1fr);

    & > div > div:first-of-type a {
      text-decoration-color: ${token('color.text', N900)};
    }
  `,
];

export const capabilityCardExtendingStyles = css`
  grid-template-columns: none !important;
`;

// Basic: Team & Product
export const cardBasicContentNoPaginationStyles = css`
  & > li:last-of-type {
    border-bottom: none;
    padding-bottom: 0;
  }
`;

export const cardBasicContentTitleStyles = css`
  font-weight: 600;
  margin-left: 6px;
`;

export const cardBasicContentTitleBarStyles = [
  flexStart,
  spaceGapComfortable,
  css`
    border-bottom: 1px solid ${token('color.border.disabled', N200A)};
    padding-bottom: ${SPACE_COMPACT}px;
    &>span: nth-of-type(2) {
      position: relative;
      top: 1px;
    }
  `,
];

// Dashboard
export const cardDashboardContentTitleStyles = css`
  margin-left: 0px;
  text-transform: capitalize;
`;

// Media query adjustments for small screen width
cardSloContentStyles.push(css`
  @media screen and (max-width: 1150px) and (min-width: 800px) {
    & > div {
      zoom: 0.85;
    }
  }
  @media screen and (max-width: 800px) {
    & > div {
      zoom: 0.65;
    }
  }
`);
capabilityCardStyles.push(css`
  @media screen and (min-width: ${SEARCH_XSMALL_BREAKPOINT}px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media screen and (min-width: ${SEARCH_LARGE_BREAKPOINT}px) {
    grid-template-columns: repeat(3, 1fr);
  }
`);

// Media query adjustments for firefox
cardSloContentStyles.push(css`
  @media screen and (max-width: 1150px) {
    & > div {
      -moz-transform: scale(0.85);
    }
  }
`);
